/// <reference path="../../../tools/typings/tsd.d.ts"/>
/// <reference path="../services.ts"/>
/// <reference path="./contract_interfaces.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export class Contract implements IDealerwareContract {
        public static $inject: string[] = [
            '$q',
            '$timeout',
            'DealerwareContractModel',
            'DealerwareWarrantyModel',
            '$DealerwareNotesFactory',
            '$DealerwareContractInvoiceFactory'
        ];

        public _currentInvoice: IDealerwareContractInvoiceCurrent;
        private _locationId: number;
        private _contractId: number;
        private NotesCollection: IDealerwareNotesCollection;
        public contractDetails: any;
        public driversLicense: any;
        public additionalDrivers: any;
        public insurance: any;
        public insuranceImage: any;
        public vehicles: any;
        public vehicleIssues: any;
        public warranty: any;

        constructor(public $q: any,
            public $timeout: any,
            public DealerwareContractModel: any,
            public DealerwareWarrantyModel: any,
            public $DealerwareNotesFactory : any,
            public $DealerwareContractInvoiceFactory : any) {}

        get currentInvoice() : IDealerwareContractInvoiceCurrent {
            if (!this._currentInvoice) {
                this._currentInvoice = this.$DealerwareContractInvoiceFactory.getCurrentInvoiceInstance(this.locationId, this.contractId);
            }
            return this._currentInvoice;
        }

        get noteCollection() : IDealerwareNotesCollection {
            if (!this.NotesCollection && this.contractId) {
                this.NotesCollection = this.$DealerwareNotesFactory.getContractInstance(this.contractDetails.data.pickup_location_id, this.contractId);
            }
            return this.NotesCollection;
        }

        get locationId() : number {
            return this._locationId;
        }

        set locationId(id: number) {
            this._locationId = id;
        }

        get contractId() : number {
            return this._contractId;
        }

        set contractId(id: number) {
            if (id !== this._contractId) {
                this.clear();
            }

            this._contractId = id;
        }

        public clear() : void {
            this.clearContractDetails();
        }

        public clearContractDetails() : void {
            this.contractDetails = undefined;
        }

        public loadContractDetails(locationId?: number, id?: number) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (locationId) { this.locationId = locationId; }
            if (id) { this.contractId = id; }

            if (!this.locationId) {
                _deferred.reject({response: {data: {message: 'Location ID is undefined'}}});
            } else if (!this.contractId) {
                _deferred.reject({response: {data: {message: 'Contract ID is undefined'}}});
            } else {
                this.DealerwareContractModel.loadContractDetails({
                    params: {
                        location_id: this.locationId,
                        id: this.contractId,
                        include_customer: true,
                        include_car: true
                    },
                    successCallback: function(returnValue: any, response: any) {
                        _self.contractDetails = returnValue;
                        _deferred.resolve({ returnValue: returnValue, response: response });
                    },
                    errorCallback: function(response: any) {
                        _deferred.reject({ response: response });
                    }
                });
            }

            return _deferred.promise;
        }

        // Though I initially considered it because DRY is always a laudable goal, it didn't seem
        // like there would be much to gain by commonizing this code and the nearly identical version in
        // $dealerwareCustomer.  I don't see any changes coming for the underlying model and how we
        // handle it.
        //
        public loadDriversLicense() : ng.IPromise<{}> {
            var _deferred = this.$q.defer(),
                _self = this;

            if (!this.locationId) {
                _deferred.reject({response : {data: {'message': 'Location ID is undefined'}}});
            } else if (!this.contractId) {
                _deferred.reject({response : {data: {'message': 'Contract ID is undefined'}}});
            } else {
                this.DealerwareContractModel.loadDriversLicense({
                    promise: true,
                    params: {
                        location_id: this.locationId,
                        id: this.contractId
                    }
                }).then(
                    function(returnValue : any,response : any){
                        _self.driversLicense = returnValue;
                        _deferred.resolve({returnValue: returnValue,response : response});
                    },
                    function(response : any) {
                        if (response.status === 404) {
                            _self.driversLicense = new _self.DealerwareContractModel();
                            _deferred.resolve({ returnValue: _self.driversLicense, response: response });
                        } else {
                            _deferred.reject(response);
                        }
                    }
                );
            }

            return _deferred.promise;
        }

        public loadedAdditionalDrivers = false;

        public loadAdditionalDrivers() : ng.IPromise<{}> {
            var _deferred = this.$q.defer(),
                _self = this;

            this.loadedAdditionalDrivers = true;

            if (!this.locationId) {
                _deferred.reject({response : {data: {'message': 'Location ID is undefined'}}});
            } else if (!this.contractId) {
                _deferred.reject({response : {data: {'message': 'Contract ID is undefined'}}});
            } else {
                this.DealerwareContractModel.loadAdditionalDrivers({
                    params: {
                        location_id: this.locationId,
                        reservation_id: this.contractId
                    },
                    successCallback: function(returnValue: any, response: any) {
                        _self.additionalDrivers = returnValue.data;
                        _deferred.resolve({ returnValue: returnValue, response: response });
                    },
                    errorCallback: function(response: any) {
                        _deferred.reject({ response: response });
                    }
                });
            }

            return _deferred.promise;
        }

        public loadInsurance(id?: number) : ng.IPromise<{}> {
            var _deferred = this.$q.defer(),
                _self = this;

            if (id) { this.contractId = id; }

            if (!this.locationId) {
                _deferred.reject({ response: { data: { message: 'Location ID is undefined' }}});
            } else if (!this.contractId) {
                _deferred.reject({ response: { data: { message: 'Contract ID is undefined' }}});
            } else {
                this.DealerwareContractModel.loadInsurance({
                    promise: true,
                    params: {
                        location_id: this.locationId,
                        id: this.contractId
                    }
                }).then(
                    function(returnValue: any) {
                        _self.insurance = returnValue;
                        _deferred.resolve({ returnValue: returnValue });
                    },
                    function(response: any) { _deferred.reject(response); }
                );
            }

            return _deferred.promise;
        }

        public loadInsuranceImage(id?: number) : ng.IPromise<{}> {
            var _deferred = this.$q.defer(),
                _self = this;

            if (id) { this.contractId = id; }

            if (!this.locationId) {
                _deferred.reject({ response: { data: { message: 'Location ID is undefined' }}});
            } else if (!this.contractId) {
                _deferred.reject({ response: { data: { message: 'Contract ID is undefined' }}});
            } else {
                this.DealerwareContractModel.loadInsuranceImage({
                    promise: true,
                    params: {
                        location_id: this.locationId,
                        id: this.contractId
                    }
                }).then(
                    function(returnValue: any) {
                        _self.insuranceImage = returnValue;
                        _deferred.resolve({ returnValue: returnValue });
                    },
                    function(response: any) { _deferred.reject(response); }
                );
            }

            return _deferred.promise;
        }

        public deleteInsuranceImage(id?: number) : ng.IPromise<{}> {
            var _deferred = this.$q.defer(),
                _self = this;

            if (id) { this.contractId = id; }

            if (!this.locationId) {
                _deferred.reject({ response: { data: { message: 'Location ID is undefined' }}});
            } else if (!this.contractId) {
                _deferred.reject({ response: { data: { message: 'Contract ID is undefined' }}});
            } else {
                this.DealerwareContractModel.deleteInsuranceImage({
                    promise: true,
                    params: {
                        location_id: this.locationId,
                        id: this.contractId
                    }
                }).finally(function() {
                    _self.insuranceImage = undefined;
                    _deferred.resolve();
                });
            }

            return _deferred.promise;
        }

        public loadCurrentInvoice() : ng.IPromise<{}> {

            return this.currentInvoice.load();
        }

        public loadVehicleContracts(id?: number) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (id) { this.contractId = id; }

            if (!this.locationId) {
                _deferred.reject({ response: { data: { message: 'Location ID is undefined' }}});
            } else if (!this.contractId) {
                _deferred.reject({ response: { data: { message: 'Contract ID is undefined' }}});
            } else {
                this.DealerwareContractModel.loadVehicleContracts({
                    params: {
                        location_id: this.locationId,
                        contract_id: this.contractId,
                        include_car: true,
                        sort_by: 'created_at',
                        sort_direction: 'desc'
                    },
                    successCallback: function(returnValue: any, response: any) {
                        _self.vehicles = returnValue;
                        _deferred.resolve({ returnValue: returnValue, response: response });
                    },
                    errorCallback: function(response: any) {
                        _deferred.reject({ response: response });
                    }
                });
            }

            return _deferred.promise;
        }

        public loadVehicleIssues(id?: number) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (id) { this.contractId = id; }

            if (!this.locationId) {
                _deferred.reject({ response: { data: { message: 'Location ID is undefined' }}});
            } else if (!this.contractId) {
                _deferred.reject({ response: { data: { message: 'Contract ID is undefined' }}});
            } else {
                this.DealerwareContractModel.loadVehicleIssues({
                    params: {
                        location_id: this.locationId,
                        contract_id: this.contractId,
                        sort_by: 'created_at',
                        sort_direction: 'desc'
                    },
                    successCallback: function(returnValue: any, response: any) {
                        _self.vehicleIssues = returnValue;
                        _deferred.resolve({ returnValue: returnValue, response: response });
                    },
                    errorCallback: function(response: any) {
                        _deferred.reject({ response: response });
                    }
                });
            }

            return _deferred.promise;
        }

        public loadWarranty(id?: number) : ng.IPromise<{}> {
            var _deferred = this.$q.defer();

            if (id) { this.contractId = id; }

            if (!this.locationId) {
                _deferred.reject({ response: { data: { message: 'Location ID is undefined' }}});
            } else if (!this.contractId) {
                _deferred.reject({ response: { data: { message: 'Contract ID is undefined' }}});
            } else {
                this.DealerwareContractModel.loadWarranty({
                    params: {
                        location_id: this.locationId,
                        contract_id: this.contractId
                    },
                    successCallback: (returnValue: any) => {
                        this.warranty = returnValue;
                        _deferred.resolve(returnValue);
                    },
                    errorCallback: (response: any) => {
                        if (response.status === 404) {
                            this.warranty = new this.DealerwareWarrantyModel({});
                            _deferred.resolve(this.warranty);
                        } else {
                            _deferred.reject({ response: response });
                        }
                    }
                });
            }

            return _deferred.promise;
        }

        public canCancel() : boolean {
            switch (this.contractDetails.data.current_state) {
                case "booked":
                case "pending_agreement":
                case "payment_declined":
                    return true;

                default:
                    return false;
            }
        }

        public cancel(id?: number) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (id) { this.contractId = id; }

            if (!this.locationId) {
                _deferred.reject({ response: { data: { message: 'Location ID is undefined' }}});
            } else if (!this.contractId) {
                _deferred.reject({ response: { data: { message: 'Contract ID is undefined' }}});
            } else {
                this.DealerwareContractModel.cancel({
                    params: {
                        location_id: this.locationId,
                        id: this.contractId
                    },
                    successCallback: function(returnValue: any, response: any) {
                        _deferred.resolve({ returnValue: returnValue, response: response });
                    },
                    errorCallback: function(response: any) {
                        _deferred.reject({ response: response });
                    }
                });
            }

            return _deferred.promise;
        }

        public canModify() : boolean {
            switch (this.contractDetails.data.current_state) {
                case "booked":
                case "started":
                    return true;
                default:
                    return false;
            }
        }

        public canEditDriversLicense() : boolean {
            return false;
        }

        public canEditInsurance() : boolean {
            switch (this.contractDetails.data.current_state) {
                case "booked":
                case "pending_agreement":
                    return true;
                default:
                    return false;
            }
        }

        public canStart() : boolean {
            return this.contractDetails.data.can_start_manually;
        }

        public isStarted() : boolean {
            switch (this.contractDetails.data.current_state) {
                case "started":
                    return true;
                default:
                    return false;
            }
        }

        public canFinish() : boolean {
            return this.isStarted();
        }

        public loadNotes() : ng.IPromise<{}> {
            var _self = this;
            var _deferred = this.$q.defer();
            this.noteCollection.loadNotes().then(
                function(response) {
                    _deferred.resolve(response);
                },
                function(response) {
                    _deferred.reject(response);
                }
            );

            return _deferred.promise;
        }
    }

    getDealerwareWebServicesModule().service("$dealerwareContract", Contract);
}
